const MapSourceBoundaryContext = React.createContext()

MapSourceBoundaryContext.displayName = 'MapSourceBoundaryContext'

export default MapSourceBoundaryContext
